import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import {
  LiveV2CompareService,
  PlateCompareResult,
} from '../../services/live-v2-compare-service';

/**
 * DEV-ONLY diagnostics page. Renders the legacy plate detail and the experimental
 * live_v2 view side by side, plus parity notes and the SEO contract. Guarded by
 * environment.liveV2CompareEnabled — in production the flag is false and the page
 * shows a disabled notice instead of calling the API. Nothing links to this route.
 */
@Component({
  selector: 'app-live-v2-compare-page',
  templateUrl: './live-v2-compare-page.component.html',
  styleUrls: ['./live-v2-compare-page.component.scss'],
})
export class LiveV2ComparePageComponent implements OnInit {
  enabled = environment.liveV2CompareEnabled === true;
  registration = '';
  loading = false;
  error: string | null = null;
  result: PlateCompareResult | null = null;

  // Convenience defaults so the page is useful immediately in dev.
  examplePlates = ['JKZ72', 'JKZ115', '1000NE', '100BOB'];

  constructor(
    private compareService: LiveV2CompareService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    const reg = this.route.snapshot.paramMap.get('registration');
    if (reg) {
      this.registration = reg.toUpperCase();
      this.runCompare();
    }
  }

  ownerLabel(owner: number | null | undefined): string {
    switch (owner) {
      case -1: return 'NONE';
      case 0: return 'DVLA';
      case 1: return 'PRIVATE';
      case 2: return 'PLATEX';
      case 3: return 'RESELLER/DEALER';
      case 5: return 'DVLA_AUCTION';
      default: return String(owner);
    }
  }

  search(): void {
    if (!this.registration) return;
    // Keep the URL shareable in dev.
    this.router.navigate(['/dev/live-v2-compare', this.registration.toUpperCase()]);
    this.runCompare();
  }

  runCompare(): void {
    if (!this.enabled || !this.registration) return;
    this.loading = true;
    this.error = null;
    this.result = null;
    this.compareService.compare(this.registration.toUpperCase()).subscribe({
      next: (res) => {
        this.result = res;
        this.loading = false;
      },
      error: (err) => {
        this.error =
          'Compare failed. The dev compare endpoint requires the API to be running ' +
          'in its Development environment (api/dev/compare/*). ' +
          (err?.status ? `HTTP ${err.status}` : '');
        this.loading = false;
      },
    });
  }
}
